export default function Bolt({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M13.5 2 4 14h6l-1.5 8L18 10h-6l1.5-8Z" fill="currentColor" />
    </svg>
  );
}
